import { Query } from '@datorama/akita';
import { LayoutState, LayoutStore } from './layout.store';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Direction } from '@angular/cdk/bidi';

@Injectable({ providedIn: 'root' })
export class LayoutQuery extends Query<LayoutState> {
  direction$: Observable<Direction>;
  customerAccounts$: Observable<any[]>;

  constructor(protected override store: LayoutStore) {
    super(store);

    this.direction$ = this.select(state =>
      state.language?.dir === 'rtl' ? 'rtl' : 'ltr'
    );

    this.customerAccounts$ = this.select(state => state.customerAccounts);
  }

  get layoutState() {
    return this.getValue();
  }

  get customerAccounts() {
    return this.layoutState.customerAccounts;
  }

  get selectedCustomerAccount() {
    return this.layoutState.customerAccount;
  }
}
